import { ActionIcon, Box, Flex, Modal, Stack, Text, TextInput } from '@mantine/core';
import { IconPlus as AddIcon } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Project } from '@/module/Author/Project';
import { ProjectCard } from '@/module/Author/Project/components/Card/ProjectCard';

import { NoContentPlaceholder } from '@/core/components';

import { useFilterAvailable } from './hooks/useFilterAvailable';

interface CriteriaProjectSelectAddModalProps {
  available: Project[];
  selected: Project[];

  close: () => void;
  onAdd: (project: Project) => void;
}

export function CriteriaProjectSelectAddModal({
  available,
  selected,
  close,
  onAdd,
}: CriteriaProjectSelectAddModalProps) {
  const { searchProps, options } = useFilterAvailable({ available, selected });
  const { t } = useTranslation();

  return (
    <Modal
      size="70vw"
      opened
      onClose={close}
      withCloseButton={false}
    >
      <Box p="sm">
        <Text
          fw="500"
          size="lg"
        >
          Proiecte
        </Text>
        <TextInput
          label="caută după titlu și autori"
          {...searchProps}
        />
      </Box>
      <Box
        mah="70vh"
        style={{ overflow: 'scroll' }}
      >
        {options.length === 0 && <NoContentPlaceholder title="Nu exista date" />}
        <Stack p="sm">
          {options.map(project => (
            <Flex
              align="center"
              key={project.id}
            >
              <ActionIcon
                mr="5px"
                onClick={() => onAdd(project)}
                variant="filled"
                aria-label={t('button.add')}
              >
                <AddIcon
                  style={{ width: '70%', height: '70%' }}
                  stroke={1.5}
                />
              </ActionIcon>
              <ProjectCard
                project={project}
                onClick={() => window.open(`/author/project/${project.id}`)}
              />
            </Flex>
          ))}
        </Stack>
      </Box>
    </Modal>
  );
}
